function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.35 19.6L16 14.159l-6.35 5.443a1 1 0 1 1-1.3-1.519l6.674-5.72a1.5 1.5 0 0 1 1.952 0l6.675 5.72a1 1 0 0 1-1.302 1.519z"
});

var SvgCollapseSmall = function SvgCollapseSmall(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "d36c185bf21c683d0c965b4d59cbc1f3.svg";
export { SvgCollapseSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/collapse-small.svg
// module id = null
// module chunks = 